'use client'

import { Button } from '@mui/material'

// Types
import type { MainButtonAtomProps } from '@/types/components/atoms/buttons/main'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const MainButtonAtom = (props: MainButtonAtomProps) => {
	// Props
	const { lng, title, type, loading, disabled, onClick } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Button
			variant="contained"
			type={type}
			disableElevation
			loading={loading}
			disabled={disabled}
			onClick={onClick}
			sx={{
				minWidth: 'auto',
				textTransform: 'inherit',
				lineHeight: 2,
				color: 'common.white',
				bgcolor: 'primary.main'
			}}
		>
			{t(title)}
		</Button>
	)
}

export default MainButtonAtom
